// Visual effects retained from the supplied design; all resources belong to this mount.
export function initializeEffects(root) {
  const disposers = [],
    frames = new Set(),
    timers = new Set();
  let active = true;
  const addEventListener = (type, handler, options) => {
    window.addEventListener(type, handler, options);
    disposers.push(() => window.removeEventListener(type, handler, options));
  };
  const requestAnimationFrame = (callback) => {
    if (!active) return 0;
    const id = window.requestAnimationFrame((time) => {
      frames.delete(id);
      if (active) callback(time);
    });
    frames.add(id);
    return id;
  };
  const setTimeout = (callback, delay) => {
    if (!active) return 0;
    const id = window.setTimeout(() => {
      timers.delete(id);
      if (active) callback();
    }, delay);
    timers.add(id);
    return id;
  };
  const IntersectionObserver = function (callback, options) {
    const observer = new window.IntersectionObserver(callback, options);
    disposers.push(() => observer.disconnect());
    return observer;
  };

  ("use strict");
  const $ = (s, c) => (c || root).querySelector(s);
  const $$ = (s, c) => Array.from((c || root).querySelectorAll(s));
  const RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  $("#yr").textContent = new Date().getFullYear();

  /* ── Reveals en scroll ─────────────────────────────────────────
   IntersectionObserver + un barrido de respaldo. El barrido existe
   porque la carga de Montserrat y de las fotos reacomoda el layout
   después del primer cálculo del observer, y algunos bloques del
   primer viewport se quedaban sin revelar. */
  function show(el) {
    if (el.classList.contains("in")) return;
    const d = parseInt(el.dataset.rvD || 0, 10);
    if (RM || !d) el.classList.add("in");
    else setTimeout(() => el.classList.add("in"), d);
  }
  const io = new IntersectionObserver(
    (es) => {
      es.forEach((e) => {
        if (e.isIntersecting) {
          show(e.target);
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.08 },
  );
  $$("[data-rv],[data-rv-clip],[data-rv-ph]").forEach((el) => io.observe(el));

  function sweep() {
    $$(
      "[data-rv]:not(.in),[data-rv-clip]:not(.in),[data-rv-ph]:not(.in)",
    ).forEach((el) => {
      // Todo lo que ya está en pantalla o quedó por encima: si el usuario saltó
      // con un ancla, esos bloques nunca dispararon el observer.
      if (el.getBoundingClientRect().top < innerHeight * 0.92) {
        show(el);
        io.unobserve(el);
      }
    });
  }
  function tickAll() {
    sweep();
    sweepFx();
  }
  addEventListener("load", () => {
    tickAll();
    setTimeout(tickAll, 300);
  });
  if (document.fonts && document.fonts.ready)
    document.fonts.ready.then(() => setTimeout(tickAll, 60));
  addEventListener("scroll", tickAll, { passive: true });
  addEventListener("resize", tickAll, { passive: true });

  /* ── Trazado SVG ─────────────────────────────────────────────── */
  $$("[data-rv-trace]").forEach((svg) => {
    const p = $(".path", svg);
    const len = p.getTotalLength();
    p.style.strokeDasharray = len;
    p.style.strokeDashoffset = len;
    svg._go = () => {
      p.style.strokeDashoffset = 0;
      svg.classList.add("in");
    };
  });

  /* ── Contadores ──────────────────────────────────────────────── */
  const nf = new Intl.NumberFormat("es-DO");
  function count(el) {
    const target = parseInt(el.dataset.n, 10);
    if (RM) {
      el.textContent = nf.format(target);
      return;
    }
    const dur = 1500,
      t0 = performance.now();
    const tick = (t) => {
      const k = Math.min((t - t0) / dur, 1);
      const e = 1 - Math.pow(2, -10 * k); // easeOutExpo
      el.textContent = nf.format(Math.round(target * (k === 1 ? 1 : e)));
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* Contadores y trazado comparten el mismo barrido que los reveals,
   para que no se queden en cero si se llega por un ancla. */
  function sweepFx() {
    $$("[data-count]:not([data-ran])").forEach((box) => {
      if (box.getBoundingClientRect().top < innerHeight * 0.8) {
        box.dataset.ran = "1";
        $$("[data-n]", box).forEach(count);
      }
    });
    $$("[data-rv-trace]:not(.in)").forEach((svg) => {
      if (svg.getBoundingClientRect().top < innerHeight * 0.8) svg._go();
    });
  }
  // Primer barrido: va aquí y no antes, porque sweepFx depende de svg._go y de nf.
  tickAll();

  /* ── Header al pasar el hero ─────────────────────────────────── */
  const hdr = $("#hdr"),
    hero = $(".hero");
  new IntersectionObserver(
    (es) => {
      hdr.classList.toggle("show", !es[0].isIntersecting);
    },
    { rootMargin: "-90px 0px 0px 0px" },
  ).observe(hero);

  /* ── Recorrido: progreso, dibujo de línea y parallax ───────────
   Todo cuelga de un solo rAF por scroll. Si el usuario pidió menos
   movimiento, no se registra nada: la página queda estática. ── */
  const quieto = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const pw = $("#pathWrap"),
    steps = $$(".step", pw || document);
  const incl = $(".incl");
  const fotos = $$(".ph");

  let ticking = false;
  function onScroll() {
    ticking = false;
    const vh = innerHeight;

    /* Barra roja de "el camino" */
    if (pw) {
      const r = pw.getBoundingClientRect();
      const k = Math.max(0, Math.min(1, (vh * 0.72 - r.top) / r.height));
      pw.style.setProperty("--prog", k * 100 + "%");
      steps.forEach((s) => {
        s.classList.toggle("on", s.getBoundingClientRect().top < vh * 0.72);
      });
    }

    /* Línea roja que se dibuja en "lo que recibes" */
    if (incl) {
      const r = incl.getBoundingClientRect();
      const k = Math.max(0, Math.min(1, (vh * 0.78 - r.top) / r.height));
      incl.style.setProperty("--draw", k * 100 + "%");
    }

    /* Parallax de las fotos: ±14 px sobre su recorrido en pantalla */
    if (!quieto) {
      fotos.forEach((ph) => {
        const r = ph.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const c = (r.top + r.height / 2 - vh / 2) / vh; // −1 … 1
        ph.style.setProperty("--pj", (c * 14).toFixed(1) + "px");
      });
    }
  }
  addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScroll);
      }
    },
    { passive: true },
  );
  addEventListener("resize", onScroll, { passive: true });
  onScroll();

  /* ── El identificador animado se congela fuera de pantalla ───── */
  const la = $("#laAnim");
  if (la) {
    new IntersectionObserver(
      (es) => {
        la.classList.toggle("is-off", !es[0].isIntersecting);
      },
      { rootMargin: "120px" },
    ).observe(la);
  }

  /* ── Mapa DR: dibujado por scroll ───────────────────────────── */
  const drPath = $(".dr-map .path");
  if (drPath && !RM) {
    const totalLen = 10633;
    const anchor = drPath.closest(".st.wide") || drPath.closest(".dr-map");
    function drawByScroll() {
      const r = anchor.getBoundingClientRect();
      const vh = innerHeight;
      // 0 cuando el elemento entra desde abajo, 1 cuando está en el tercio superior
      const p = Math.max(0, Math.min(1, (vh * 0.9 - r.top) / (vh * 0.75)));
      drPath.style.strokeDashoffset = totalLen * (1 - p);
    }
    addEventListener("scroll", drawByScroll, { passive: true });
    drawByScroll();
  }

  /* ── Escalonado de las tarjetas de perfil ─────────────────────
   Se marcan desde JS para que sin JS salgan visibles de una vez.
   Si ya están en pantalla al marcarlas, se muestran sin parpadeo. */
  $$(".prof .p").forEach((p, i) => {
    p.style.setProperty("--i", i);
    p.setAttribute("data-rv", "");
    if (p.getBoundingClientRect().top < innerHeight * 0.92) show(p);
    else io.observe(p);
  });

  const details = Array.from(root.querySelectorAll(".faq details"));
  details.forEach((item) => {
    const toggle = () => {
      if (item.open)
        details.forEach((other) => {
          if (other !== item) other.open = false;
        });
    };
    item.addEventListener("toggle", toggle);
    disposers.push(() => item.removeEventListener("toggle", toggle));
  });
  return () => {
    active = false;
    disposers.forEach((dispose) => dispose());
    frames.forEach(window.cancelAnimationFrame);
    timers.forEach(window.clearTimeout);
  };
}
